import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import {
  aggregateMapConfig
} from 'dataviz/config/map';

import renderVizMap from 'dataviz/rendering/renderVizMap';

// components
import DataViz from 'dataviz/DataViz';

const baseString = 'vra-viz-map';
const classString = classNames({
  [`${baseString}`]: true
});
const VizMap = ({
  config,
  zones
}) => {
  const mapConfig = aggregateMapConfig(config);
  return zones ? (
    <section className={classString}>
      <DataViz renderMethod={renderVizMap({ config: mapConfig, zones })} />
    </section>
  ) : null;
};
VizMap.propTypes = {
  config: propTypes.object,
  zones: propTypes.object
};
export default VizMap;
